import TrainingDataTable from "../../../../container/TrainingDataTable";

interface StatisticsReportProps {
  domain_id: string;
  financial_year: string;
}

const StatisticsReport = ({
  domain_id,
  financial_year,
}: StatisticsReportProps) => {
  return (
    <TrainingDataTable domain_id={domain_id} financial_year={financial_year} />
  );
};

export default StatisticsReport;
